import { fetchAPI } from '../../../services/apiClient';

// ── Tipos ────────────────────────────────────────────────────────────────────

export interface GananciaData {
  fecha: string;
  ventas: number;
  premios: number;
  comisiones: number;
  ganancia: number;
}

export interface RiesgoNumero {
  numero: string;
  sorteo_id: string | null;
  sorteo_nombre: string | null;
  monto_vendido: number;
  riesgo: number;
  nivel: 'BAJO' | 'MEDIO' | 'ALTO';
  multiplicador: number;
}

export interface Alerta {
  tipo: string;
  nivel: 'BAJO' | 'MEDIO' | 'ALTO';
  mensaje: string;
  dato: Record<string, unknown>;
}

export interface RiesgoNumeroValidacion {
  permitido: boolean;
  nivel: 'BAJO' | 'MEDIO' | 'ALTO';
  riesgo_actual: number;
  riesgo_proyectado: number;
  mensaje: string | null;
}

// ── Funciones de API ─────────────────────────────────────────────────────────

export async function fetchGanancia(fecha?: string): Promise<GananciaData> {
  const params = new URLSearchParams();
  if (fecha) params.set('fecha', fecha);
  const qs = params.toString() ? `?${params.toString()}` : '';
  return fetchAPI<GananciaData>(`/analitica/ganancia${qs}`);
}

export async function fetchRiesgo(
  sorteoId?: string,
  fecha?: string,
): Promise<RiesgoNumero[]> {
  const params = new URLSearchParams();
  if (sorteoId) params.set('sorteo_id', sorteoId);
  if (fecha) params.set('fecha', fecha);
  const qs = params.toString() ? `?${params.toString()}` : '';
  return fetchAPI<RiesgoNumero[]>(`/analitica/riesgo${qs}`);
}

export async function fetchAlertas(fecha?: string): Promise<Alerta[]> {
  const params = new URLSearchParams();
  if (fecha) params.set('fecha', fecha);
  const qs = params.toString() ? `?${params.toString()}` : '';
  return fetchAPI<Alerta[]>(`/analitica/alertas${qs}`);
}

export async function fetchRiesgoNumero(
  num1: string,
  monto: number,
  sorteoId?: string,
): Promise<RiesgoNumeroValidacion> {
  const params = new URLSearchParams({ num1, monto: String(monto) });
  if (sorteoId) params.set('sorteo_id', sorteoId);
  return fetchAPI<RiesgoNumeroValidacion>(
    `/analitica/riesgo/numero?${params.toString()}`,
  );
}
